export default [{
  name: 'intro',
  path: '/intro',
  meta: {
    layout: 'LegacyLayoutFluid'
  },
  component: require('@/pages/intro/Intro.vue').default
}]
